// extracted by mini-css-extract-plugin
export var awards_title = "ourAlliance-module--awards_title--71ad4";
export var client_logo_LeftBox = "ourAlliance-module--client_logo_LeftBox--6c293";
export var client_logo_rightBox = "ourAlliance-module--client_logo_rightBox--1d8d0";
export var client_logo_wrap = "ourAlliance-module--client_logo_wrap--4f06b";
export var client_partner_Leftbox = "ourAlliance-module--client_partner_Leftbox--27eba";
export var client_partner_wrap = "ourAlliance-module--client_partner_wrap--76b80";
export var slider_box = "ourAlliance-module--slider_box--ef15d";